import { gql } from '@apollo/client';

const ENROLL_SHORT_TERM_ARRANGEMENT_OFFER = gql`
  mutation EnrollShortTermArrangementOffer(
    $customerId: String!
    $accountId: String!
    $numberOfCycles: Int!
    $minimumPaymentDue: Long!
  ) {
    enrollShortTermArrangementOffer(
      request: {
        customerId: $customerId
        accountId: $accountId
        numberOfCycles: $numberOfCycles
        minimumPaymentDue: $minimumPaymentDue
      }
      channel: AGENT_TOOL
    ) {
      __typename
    }
  }
`;

export { ENROLL_SHORT_TERM_ARRANGEMENT_OFFER };
